<template>
  <div class="d-flex justify-center align-center my-5">
    <v-tooltip v-if="noEventsInWorkflow" location="bottom">
      <template v-slot:activator="{ props }">
        <v-btn
          size="small"
          icon="mds:add"
          v-bind="props"
          @click.prevent="addStartPoint"
          :disabled="$store.state.isWorkflowDisabled"
        />
        <span>&nbsp;&nbsp;&nbsp;Add start point</span>
      </template>
      <span>No events in the workflow. Click on 'Add start point' to add one.</span>
    </v-tooltip>
    <v-tooltip v-else-if="!$route.params.eventId" location="bottom">
      <template v-slot:activator="{ props }">
        <div v-bind="props">
          Select event to <b>add cards</b>
        </div>
      </template>
      <span>To add a card, first select an event from the workflow</span>
    </v-tooltip>
    <template v-else-if="defaultRequirementType?.title">
      <v-tooltip location="bottom" v-model="showTooltip">
        <template v-slot:activator="{ props }">
          <v-progress-circular
            v-if="addCardLoading"
            size="14"
            width="1"
            class="mx-1"
            indeterminate>
          </v-progress-circular>
          <div v-else v-bind="props">
            <v-btn
              size="small"
              icon="mds:add"
              :disabled="$store.state.isWorkflowDisabled"
              class="add-requirement-type-card-plus-button"
              :style="'background-color: ' + (isHovered ? getBackgroundColour : 'white') + '!important;'"
              @click.prevent="addCard"
              @mouseover="isHovered = true"
              @mouseleave="isHovered = false"
              color="white"
            />
          </div>
          <span>&nbsp;&nbsp;&nbsp;Add <b>{{ defaultRequirementType?.title }}</b> to the selected event</span>
        </template>
        Add one card of the default type '{{ defaultRequirementType?.title }}' to the selected event
      </v-tooltip>
      <template v-if="workflow.aiDescription">
        <v-tooltip location="bottom">
          <template v-slot:activator="{ props }">
            <span v-bind="props">. Or use AI:&nbsp;&nbsp;</span>
            <div v-bind="props" class="add-requirement-type-card-ask-ai-button-wrapper">
              <v-btn
                icon="mds:temp-preferences-custom"
                size="small"
                :disabled="$store.state.isWorkflowDisabled"
                class="add-requirement-type-card-ask-ai-button"
                :style="'background-color: ' + (isHoveredAI ? getBackgroundColour : 'white') + '!important;'"
                @click="addCardWithAi($route.params.eventId, defaultRequirementType?.id)"
                @mouseover="isHoveredAI = true"
                @mouseleave="isHoveredAI = false"
              />
            </div>
          </template>
          Add one card (of default type) with AI
        </v-tooltip>
      </template>
    </template>
    <template v-else>
      <div>
        <aggregate-type-selector
          :requirementTypes="requirementTypes"
          type="default"
        />
      </div>
    </template>
  </div>
</template>

<script>
import workflowApi from '@/api/workflowApi'
import { mapState, mapGetters } from 'vuex'
import requirementTypesApi from '@/api/requirementTypesApi'
import AggregateTypeSelector from '@/components/AggregateTypeSelector'
import { EventBus } from '@/event-bus/event-bus.js'

export default {
  components: {
    AggregateTypeSelector
  },

  data () {
    return {
      addCardLoading: false,
      showTooltip: false,
      isHovered: false,
      isHoveredAI: false
    }
  },

  computed: {
    ...mapState({
      workflow: state => state.workflow.workflow,
      events: state => state.workflow.workflow.eventsJson,
      requirementTypes: state => state.requirementTypes.requirementTypes
    }),
    ...mapGetters({
      defaultRequirementType: 'requirementTypes/defaultRequirementType'
    }),
    noEventsInWorkflow () {
      return !this.events || Object.keys(this.events).length === 0
    },
    getBackgroundColour () {
      const cardType = this.defaultRequirementType
      const res = requirementTypesApi.getBackgroundColour(cardType)
      return res
    }
  },

  methods: {
    addCardWithAi (eventId, cardTypeId) {
      this.isHoveredAI = false
      EventBus.$emit('add-card-with-ai', eventId, cardTypeId)
    },
    async addStartPoint () {
      const newEventId = await workflowApi.addEventToWorkflow({
        type: 'bpmn:Task',
        parents: ['start'],
        description: 'New event'
      })
      this.$router.push({ path: '/workflow/' + this.workflow.projectId + '/' + this.workflow.id + '/' + newEventId }).catch(() => { })
    },
    async addCard () {
      this.showTooltip = false
      this.isHovered = false
      this.addCardLoading = true
      const res = await workflowApi.createRequirementJson(this.$route.params.id, this.$route.params.eventId)
      this.addCardLoading = false
      if (res.requirements?.length) {
        this.$emit('focus-card', { id: res.requirements[0].id })
      }
    }
  }
}
</script>

<style scoped>
.add-requirement-type-card-plus-button {
  width: 20px;
  height: 20px;
  font-size: 12px;
}

button.add-requirement-type-card-plus-button:hover,
button.add-requirement-type-card-ask-ai-button:hover {
  color: white !important;
}

button.add-requirement-type-card-plus-button,
button.add-requirement-type-card-ask-ai-button {
  transition: background-color 0.2s ease, color 0.2s ease !important;
}

</style>
